import {useCompanyTariffGuard} from '../../../modules/company-tariff';
import {FC, useContext, useEffect, useState} from 'react';
import {useRecoilStateLoadable} from 'recoil';

import Fallback from '../../../ui/fallback/Fallback';
import NotFoundError from '../../../ui/not-found/NotFoundError';
import NavCards from '../../../ui/nav-cards/NavCards';
import AddIcon from '@mui/icons-material/Add';
import {Button, Stack} from '@mui/material';
import {ModalNewTaskLocation} from '../../../components/Dictionaries/TaskLocations/task-location/ModalNewTaskLocation';

import {EventBusContext} from '../../../providers/EventBus';

import {taskLocationsDictQuery} from '../../../store/taskLocations/selectors';

import {ITaskLocationsDict} from '../../../shared/types/taskLocationsDict.types';

import {green} from '@mui/material/colors';

import styles from './TaskLocations.module.scss';

const TaskLocationsPage: FC = () => {
  const {checkTariff, tariffLoading} = useCompanyTariffGuard();
  const [{state, contents}, setTaskLocations] = useRecoilStateLoadable(taskLocationsDictQuery);
  const [open, setOpen] = useState(false);
  const {bus} = useContext(EventBusContext);

  const toggleModalToCreate = () => {
    if (!open && !checkTariff()) return;
    setOpen(!open);
  };

  useEffect(() => {
    state === 'hasValue' && setTaskLocations(contents);

    state === 'hasError' &&
      bus?.emit('error', [
        contents,
        {
          toastId: 'taskLocations',
        },
      ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return state === 'loading' ? (
    <Fallback />
  ) : state === 'hasError' ? (
    <NotFoundError />
  ) : (
    <div className={styles.deviceTypes}>
      <Stack direction="row" sx={{justifyContent: 'center', mt: 4}}>
        <Button
          onClick={toggleModalToCreate}
          disabled={tariffLoading}
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          sx={{
            height: '40px',
            fontSize: '0.87rem',
            whiteSpace: 'nowrap',
            letterSpacing: '0',
            backgroundColor: green[500],
            textTransform: 'none',
            '&:hover': {
              backgroundColor: green[600],
            },
          }}
        >
          Добавить место установки
        </Button>
      </Stack>
      <div className={styles.navCards}>
        <NavCards
          variant="grid"
          menu={contents.content.map((item: ITaskLocationsDict) => ({
            link: `/dictionaries/taskLocations/${item.code}`,
            title: item.name,
          }))}
        />
      </div>
      {open && <ModalNewTaskLocation open={open} handleClose={toggleModalToCreate} />}
    </div>
  );
};

export default TaskLocationsPage;
